/** Format dùng chung cho các thẻ shop/ưu đãi trang chủ: ảnh cover/avatar, địa chỉ rút gọn, điểm. */
import { get } from "utils/lodash";
import helper from "utils/helper";

/** Ảnh nền card: ưu tiên gallery (ảnh không gian thật), fallback avatar/logo */
export const shopCover = (shop: any): string => {
  const g =
    get(shop, "gallery.0.sizes.card.url") || get(shop, "gallery.0.url") || "";
  const a =
    get(shop, "avatar.sizes.card.url") || get(shop, "avatar.url") || "";
  return helper.imageUrl(g || a) || "";
};

export const shopAvatar = (shop: any): string =>
  helper.imageUrl(
    get(shop, "avatar.sizes.thumbnail.url") || get(shop, "avatar.url") || "",
  ) || "";

/** Địa chỉ rút gọn: bỏ "TP.HCM / Ho Chi Minh City / Vietnam" ở đuôi, giữ tối đa 2 phần cuối có ý nghĩa */
export const shortAddress = (address?: string): string => {
  if (!address) return "";
  const junk =
    /^(tp\.?\s*hcm|tp\.?\s*hồ chí minh|thành phố hồ chí minh|ho chi minh city|hồ chí minh|vietnam|việt nam|viet nam)$/i;
  const parts = address
    .split(",")
    .map((p) => p.trim())
    .filter((p) => p && !junk.test(p));
  if (parts.length <= 2) return parts.join(", ");
  return `${parts[0]}, ${parts[parts.length - 1]}`;
};

export const roundRating = (r?: number): string =>
  typeof r === "number" && r > 0 ? r.toFixed(1) : "";
